import * as constants from './constants'

export const getUserLocation = (userLocation, zoom = 13) => ({
    type: constants.GET_USER_LOCATION,
    userLocation,
    zoom,
})

export const loadGoogleAPI = () => ({
    type: constants.MAP_LOAD_GOOGLE_API,
})

export const googleAPILoaded = () => ({
    type: constants.MAP_GOOGLE_API_LOADED,
})

export const setActiveLocation = (activeLocation, scrollToActiveLocation = false, location) => ({
    type: constants.SET_MAP_ACTIVE_LOCATION,
    activeLocation,
    scrollToActiveLocation,
    location,
})

export const setHoveredLocation = hoveredLocation => ({
    type: constants.SET_MAP_HOVERED_LOCATION,
    hoveredLocation,
})

export const setActiveSearchLocation = (activeSearchLocation, scrollToActiveLocation = false) => ({
    type: constants.SET_MAP_ACTIVE_SEARCH_LOCATION,
    activeSearchLocation,
    scrollToActiveLocation,
})

export const setDateTime = (start, end) => ({
    type: constants.SET_MAP_SEARCH_DATETIME,
    start,
    end,
})

export const setFilters = filters => ({
    type: constants.SET_MAP_FILTERS,
    filters,
})

export const setLocation = searchLocation => ({
    type: constants.SET_MAP_LOCATION,
    searchLocation,
})

export const setMaximumMapBounds = maxBounds => ({
    type: constants.SET_MAXIMUM_MAP_BOUNDS,
    maxBounds,
})

export const setMapBounds = (searchLocation, zoom, bounds = false) => ({
    type: constants.SET_MAP_BOUNDS,
    searchLocation,
    zoom,
    bounds,
})

export const setSearchMode = searchMode => ({
    type: constants.SET_MAP_SEARCH_MODE,
    searchMode,
})

export const setSearchResultsView = mode => ({
    type: constants.SET_MAP_SEARCH_RESULTS_VIEW,
    mode,
})

export const setZoom = zoom => ({
    type: constants.SET_MAP_ZOOM,
    zoom,
})

export const findMapLocations = params => ({
    type: constants.FIND_MAP_LOCATIONS,
    params,
})

export const receivedMapResults = (results, resultsCount, placesOfInterest) => ({
    type: constants.RECEIVED_MAP_RESULTS,
    results,
    resultsCount,
    placesOfInterest,
})

export const triggerSearch = () => ({
    type: constants.TRIGGER_SEARCH,
})

export const setRates = rates => ({
    type: constants.SET_RATES,
    rates,
})
